import { StyleSheet, Text, View } from "react-native";
import React from "react";

const Receipt = () => {
  return (
    <View>
      <Text>Receipt</Text>
    </View>
  );
};

export default Receipt;

const styles = StyleSheet.create({});
